var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.auth.currentUser && _vm.currentUser)?_c('div',[(
        _vm.currentUser.role.toLowerCase() == 'doctor' ||
          _vm.currentUser.role.toLowerCase() == 'nurse' ||
          _vm.currentUser.role.toLowerCase() == 'staff'
      )?_c('ProxyRoomLayout',{attrs:{"proxy":_vm.currentUser}}):(_vm.currentUser.role.toLowerCase() == 'patient')?_c('PatientRoomLayout',{attrs:{"user":_vm.currentUser}}):_vm._e()],1):(!_vm.auth.currentUser)?_c('div',[_c('PublicRoomLayout')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }